import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {Company} from 'src/app/interfaces/company.interface';
import { formatLargeNumber } from '../../../utils/number.utils';
import { Store } from '@ngrx/store';
import { enrichProfile, enrichProfileSuccess } from '../../../state/search/search.actions';
import { Actions, ofType } from '@ngrx/effects';
import { take } from 'rxjs';

@Component({
  selector: 'app-company-insights',
  templateUrl: './company-insights.component.html',
  styleUrls: ['./company-insights.component.scss']
})
export class CompanyInsightsComponent {

  @Input() edit: boolean | undefined;
  @Input() reportSearch: any;
  @Input() company: Company;
  @Input() aside: boolean;
  @Output() editContactModalRequested = new EventEmitter<{ emails: string[]; phoneNumbers: string[]; contactType: string }>();

  formatNumber = formatLargeNumber;
  isEnriched: boolean = false;

  constructor(private store: Store, private actions$: Actions) {}

  ngOnChanges(changes: SimpleChanges): void {
    // Check if reportSearch changed and update isEnriched
    if (changes['reportSearch'] && this.reportSearch) {
      this.isEnriched = this.reportSearch.is_enrich === 1;
    }
  }

  // Optional: Add a method to check if enrichment is needed
  shouldShowEnrichmentPrompt(): boolean {
    return !this.isEnriched && this.company !== null;
  }

  onEnrichProfile(): void {
    if (this.reportSearch?.id) {
      this.store.dispatch(enrichProfile({ searchId: this.reportSearch.id }));

      this.actions$.pipe(
        ofType(enrichProfileSuccess),
        take(1)
      ).subscribe(() => {
        this.onProfileEnriched();
      });
    }
  }

  onProfileEnriched(): void {
    // Update the local state immediately for better UX
    this.isEnriched = true;

    // Update the reportSearch object
    if (this.reportSearch) {
      this.reportSearch.is_enrich = 1;
    }
  }

}
